import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableList = _resolveComponent("TableList")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_TableList, {
    ref: "TableList",
    dataList: _ctx.list,
    columnAllData: _ctx.columnAllData,
    tableName: _ctx.TableName,
    permissionName: _ctx.permissionName,
    showSelection: false,
    canRefresh: false,
    canChangeColumn: false,
    canCommand: false,
    isShowPagination: false,
    handleDefaultWidth: 240,
    maxHight: 224
  }, null, 8, ["dataList", "columnAllData", "tableName", "permissionName"])), [
    [_directive_loading, _ctx.listLoading]
  ])
}